module.exports = __webpack_public_path__ + "img/logo4.44ea8774.png";